export default {
    prescription: [],
    prescriptionId: null,
    revision: null,
    patientId: null,
    encounterId: null,
    contextPrescriptions: [],
    nextCursor: null,
    hasMore: false,
    contextSelectionRequired: false,
    readonly: false,
    initialized: false,
    selectedDrug: null,
    edition: false,
    files: [],
    shareDate: null,
    issuedPagesSnapshot: null,
    clinicalHandouts: [],
    professionalSnapshot: null,
}
